module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ja":{"button":{"today":"今日","yesterday":"昨日","past_7_days":"過去7日間","past_30_days":"過去30日間","cancel":"キャンセル","ok":"OK"}},"en":{"button":{"today":"Today","yesterday":"Yesterday","past_7_days":"Past 7 days","past_30_days":"Past 30 days","cancel":"Cancel","ok":"OK"}}}')
  delete Component.options._Ctor
}
